import { SearchFields } from 'api/search/fetchSearchSettingsListApi'
import { Cursor, ProfileItem } from 'api/search/search.types'
import {
  DefaultSearchForm,
  defaultSearchForm,
} from 'components/page/MainSearchSettings/constants'
import { Interest } from 'reducers/interests/interests.types'

export interface MainSearchState {
  loaded: boolean
  loading: boolean
  isChangeField: boolean
  settingsFields: SearchFields
  form: DefaultSearchForm
  lexemes: Record<string, string>
  currentLocationAutocomplete: {
    locationString: string
  }
  formSettings: Record<string, any>
  interests: Interest[]
  showInterests: boolean
  defaultStateForm: DefaultSearchForm
  settingsReseting: boolean
  settingsReseted: boolean
  formSaving: boolean
  formSaved: boolean
  resultLoading: boolean
  resultLoaded: boolean
  firstLoaded: boolean
  hasErrorAdvancedSearch: boolean
  searchResult: {
    items: ProfileItem[]
    serverItemsCount: number
    isEnd: boolean
    cursor: Cursor
  }
  searchSettingsLoading: boolean
  searchSettingsLoaded: boolean
  searchListFetchingServerError: boolean
}

export const initialState: MainSearchState = {
  loaded: false,
  loading: false,
  isChangeField: false,
  settingsFields: {} as SearchFields,
  form: defaultSearchForm,
  lexemes: {},
  currentLocationAutocomplete: {
    locationString: '',
  },
  formSettings: {
    additionalParams: {
      minAge: 0,
      maxAge: 0,
    },
  },
  interests: [] as Interest[],
  showInterests: false,
  defaultStateForm: {} as DefaultSearchForm,
  settingsReseting: false,
  settingsReseted: false,
  formSaving: false,
  formSaved: false,
  resultLoading: false,
  resultLoaded: false,
  firstLoaded: false,
  hasErrorAdvancedSearch: false,
  searchResult: {
    items: [],
    serverItemsCount: 0,
    isEnd: false,
    cursor: {
      negativeTags: null,
      searchId: 0,
      searcherOffset: 0,
      type: null,
    } as Cursor,
  },
  searchSettingsLoading: false,
  searchSettingsLoaded: false,
  searchListFetchingServerError: false,
}
